import React, { useEffect, Suspense } from "react";
import ModalLoader from "./components/helpers/ModalLoader";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader } from "./slices/loader";
import RouteTracker from "./components/helpers/RouteTracker";
import { ToastContainer } from "react-toastify";
import Header from "./components/layout/Header/Header";
import Home from "./components/layout/Home";
import BottomNav from "./components/layout/mobile/BottomNav";
import { ChakraProvider, defaultSystem } from "@chakra-ui/react";
import Footer from "./components/layout/Footer";
import { Routes, Route } from "react-router-dom";
import ProductDetails from "./components/product/ProductDetails";
import AccountInfo from "./components/profile/AccountInfo";
import { system } from "./theme/Chakra";
import Filters from "./components/shop/Filters";
import LogIn from "./components/auth/LogIn";
import Contact from "./components/contact/Contact";
import Checkout from "./components/cart/Checkout";
import SecureRoute from "./components/helpers/SecureRoute";
import Favourites from "./components/profile/Favourites";
import LoginModal from "./components/auth/LoginModal";
import CartPage from "./components/cart/CartPage";
import TermsAndConditions from "./components/contact/TermsAndConditions";
import ExchangeReturnPolicy from "./components/contact/ExchangeReturnPolicy";
import RefundPolicy from "./components/contact/RefundPolicy";
import ShippingPolicy from "./components/contact/ShippingPolicy";
import PrivacyPolicy from "./components/contact/PrivacyPolicy";
import ScrollToTop from "./components/helpers/Scroll";

function App() {
  const { isLoading } = useSelector((state) => state.loader);
  const dispatch = useDispatch();

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(hideLoader(false));
    }, 3000); // fallback after 3s

    return () => clearTimeout(timeout);
  }, [dispatch]);


  useEffect(() => {
  const unlockScroll = () => {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
  };

  unlockScroll(); // initial

  window.addEventListener("click", unlockScroll);
  window.addEventListener("touchstart", unlockScroll);
  window.addEventListener("scroll", unlockScroll);

  return () => {
    window.removeEventListener("click", unlockScroll);
    window.removeEventListener("touchstart", unlockScroll);
    window.removeEventListener("scroll", unlockScroll);
  };
}, []);

  return (
    <>
      {isLoading && <ModalLoader color="#F67280" size={17} />}
      <ChakraProvider value={system}>
        <main className="wrapper">
          <RouteTracker />
          <ScrollToTop />
          <ToastContainer position="top-center" />
          <Header />
          <LoginModal />

          <Routes>
            <Route
              exact
              path="/checkout"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <Checkout />
                </Suspense>
              }
              key="1"
            />
            ,
            <Route
              exact
              path="/product/:id"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <ProductDetails />
                </Suspense>
              }
              key="1"
            />
            ,
            <Route exact path="home/:page" element={<Home />} />
            <Route
              exact
              path="/shop/:category"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <Filters />
                </Suspense>
              }
              key="1"
            />
            ,
            <Route
              exact
              path="/shop"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <Filters />
                </Suspense>
              }
              key="1"
            />
            ,
            <Route path="" element={<Home />} />
            <Route exact path="/login" element={<LogIn />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route
              path="/terms-and-conditions"
              element={
               
                  <TermsAndConditions />
        
              }
            />
            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route exact path="/exchange-return-policy" element={<ExchangeReturnPolicy />} />
            <Route exact path="/refund-policy" element={<RefundPolicy />} />
            <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
            <Route
              exact
              path="/account"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <SecureRoute>
                    <AccountInfo />
                  </SecureRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/wishlist"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <SecureRoute>
                    <Favourites />
                  </SecureRoute>
                </Suspense>
              }
            />
            <Route
              exact
              path="/cart"
              element={
                <Suspense fallback={<ModalLoader />}>
                  <SecureRoute>
                    <CartPage />
                  </SecureRoute>
                </Suspense>
              }
            />

          </Routes>
          <Footer />
          <BottomNav />
        </main>
      </ChakraProvider>
    </>
  );
}

export default App;
